module.exports = __webpack_public_path__ + "static/gm-1-c8e6c6038534d1b24a4f3f5c660aad80.jpg";